import { useQuery } from "@tanstack/react-query";
import { DataLakeBackends } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { DATA_LAKE_CONFIG_QUERY_KEYS } from "data-lake/Constants";
const useActiveDataLakeBackendType = () => {
  const { data, isSuccess, error } = useQuery({
    queryKey: [...DATA_LAKE_CONFIG_QUERY_KEYS, "active", "type"],
    queryFn: () => defaultOnError(
      DataLakeBackends.getActiveBackendType(),
      "Loading the active Data Lake backend type failed with status",
      "Could not load the active Data Lake backend type."
    )
  });
  return {
    data: data == null ? void 0 : data.type,
    isSuccess,
    error
  };
};
export default useActiveDataLakeBackendType;
